import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          padding: '60px 24px', textAlign: 'center', minHeight: '50vh',
        }}>
          <div style={{ fontSize: 44, marginBottom: 12 }}>⚠️</div>
          <div style={{
            fontFamily: 'var(--font-d)', fontSize: 22, fontWeight: 900,
            letterSpacing: 2, textTransform: 'uppercase', color: 'var(--head)', marginBottom: 8,
          }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 13, color: 'var(--muted)', maxWidth: 400, lineHeight: 1.6, marginBottom: 20 }}>
            An unexpected error occurred. Try refreshing the page. If the problem persists, contact support.
          </div>
          <div style={{
            fontSize: 11, color: 'var(--red)', background: 'rgba(192,57,43,.1)',
            padding: '8px 14px', borderRadius: 4, border: '1px solid rgba(192,57,43,.2)',
            maxWidth: 500, wordBreak: 'break-word', marginBottom: 20,
          }}>
            {this.state.error?.message || 'Unknown error'}
          </div>
          <button
            className="btn"
            onClick={() => { this.setState({ hasError: false, error: null }); }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
